import { render, staticRenderFns } from "./orderChart.vue?vue&type=template&id=1b25e34c"
import script from "./orderChart.vue?vue&type=script&lang=js"
export * from "./orderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports